import { render, staticRenderFns } from "./PriceMismatchModal.vue?vue&type=template&id=ee4edcfc&scoped=true"
import script from "./PriceMismatchModal.vue?vue&type=script&lang=js"
export * from "./PriceMismatchModal.vue?vue&type=script&lang=js"
import style0 from "./PriceMismatchModal.vue?vue&type=style&index=0&id=ee4edcfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4edcfc",
  null
  
)

export default component.exports